import { Modal } from "../../../theme/Component/Modal";
import { useState, useEffect } from 'react';
import { FinanceService } from '../../../../core/services/FinanceService';
import { ModalConfirm } from '../../../theme/Component/ModalConfirm';
import { Singleton } from "../../../../core/services/Singleton";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { HealthIDNoteCatalog } from "./HealthIDNoteCatalog";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { PrintJson } from "../../../theme/Component/PrintJson";

interface Props {
    id: number;
    bean: any;
    json?:any;
    updateEvent: any;
    idType: number;
}
export const ButtonHealthID = ({ idType, id, bean, updateEvent,json }: Props) => {

    const single = Singleton.getInstance()
    const service = new FinanceService();
    const [modalNote, setModalNote] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [confirm, setConfirm] = useState<any>({ name: 'Confirmación', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [miBean, setMibean] = useState<any>({});

    useEffect(() => {
        setMibean(bean);
    }, [bean])


    useEffect(() => {
    }, [miBean.IDLn])

    const updateBean = () => {
        _single.deleteCacheItem("budgetChild_");
        _single.deleteCacheItem("treeBusget_");
        service.updateHealthID(miBean).subscribe(
            (resp: any) => {
                console.log("Update : ", resp);
                updateEvent();
                setModal({ ...modal, 'view': false });
                // single.update(miBean);
            }
        );

    }

    const deleteID = () => {
        service.deleteHealthID(bean.IDLn).subscribe(
            (resp: any) => {
                updateEvent();
                setConfirm({ ...confirm, ['view']: false });
                // single.delete(bean.IDLn, miBean);
            }
        )

    }

    return (
        <>
            {single.canDelete() &&
                <i className="ri-file-reduce-line cursor btnicon_sm" title="Eliminar" onClick={() => setConfirm({ ...confirm, ['view']: true })}></i>
            }

            {single.canEdit() &&
                <i className="ri-edit-2-line cursor btnicon_sm" title="Editar" onClick={() => {
                    setModal({ ...modal, 'view': true });
                }}></i>
            }
            <i className="ri-sticky-note-fill cursor btnicon_sm" title="Notas" onClick={() => {
                    setModalNote({ ...modalNote, 'view': true });
                }}></i>
            <Modal modal={modal} updateModal={setModal} eventModal={updateBean}>
                <div className="row">
                    <div className="col-md-12">
                        <label>Nombre</label>
                        <textarea className="form-control" value={miBean.Name} onChange={(e) => { setMibean({ ...miBean, 'Name': e.target.value }) }}></textarea>
                    </div>
                    <div className="col-md-6">
                        <label>Utilizar Prefijo para Documento</label>
                        <BasicSwitch label="" estado={miBean.UseDocumentMnemonic} eventChange={(e) => { setMibean({ ...miBean, "UseDocumentMnemonic": e }) }} />
                    </div>
                    {miBean.UseDocumentMnemonic && <>
                    <div className="col-md-6">
                        <label>Prefijo de Documento</label>
                        <input type="text" className="form-control" value={miBean.DocumentMnemonic} onChange={(e) => { setMibean({ ...miBean, "DocumentMnemonic": e.target.value }) }} />
                    </div>
                                  </>}
                                  <div className="col-md-12">
                                    <PrintJson json={miBean}/>
                                  </div>
                </div>
            </Modal>
            <Modal modal={modalNote} updateModal={setModalNote}>
                <div className="row">
                    <div className="col-md-2">
                            <label>JsonCode:</label>
                    </div>
                    <div className="col-md-6 mt-1 p-2">
                             {json}
                    </div>
                    
                    <HealthIDNoteCatalog jsonCode={json}/>
                </div>
            </Modal>
            <ModalConfirm modal={confirm} updateModal={setConfirm} eventModal={deleteID}>
                Eliminar el item
            </ModalConfirm>
        </>
    )
}